import clsx from 'clsx';
import { type ComponentPropsWithoutRef, type ForwardedRef, forwardRef } from 'react';

import { type IconDefinition, renderIcon } from './util';

export interface DescriptionListProps extends ComponentPropsWithoutRef<'dl'> {}

export const DescriptionList = forwardRef(function DescriptionList(
    props: DescriptionListProps,
    ref: ForwardedRef<HTMLDListElement>
) {
    return <dl ref={ref} {...props} className={clsx('flex flex-col gap-0.5', props.className)} />;
});

export interface DescriptionTermProps extends ComponentPropsWithoutRef<'dt'> {}

export const DescriptionTerm = forwardRef(function DescriptionTerm(
    props: DescriptionTermProps,
    ref: ForwardedRef<HTMLDListElement>
) {
    return (
        <dt
            ref={ref}
            {...props}
            className={clsx('flex items-center gap-1.5 text-muted', props.className)}
        />
    );
});

export interface DescriptionDetailProps extends ComponentPropsWithoutRef<'dd'> {}

export const DescriptionDetail = forwardRef(function DescriptionDetail(
    props: DescriptionDetailProps,
    ref: ForwardedRef<HTMLElement>
) {
    return (
        <dd ref={ref} {...props} className={clsx('flex items-center gap-1.5', props.className)} />
    );
});

export interface DescriptionListIconProps {
    icon: IconDefinition;
}

export function DescriptionListIcon(props: DescriptionListIconProps) {
    return renderIcon(props.icon, { className: 'size-3 shrink-0' });
}
